import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { Subscription } from 'rxjs';
import { userActions } from 'src/app/models/enums/user-permissions.enum';
import { OrganizationDataService } from 'src/app/services/organization-data.service';
import { UserUtilityService } from 'src/app/services/user-utility.service';
import { Organization } from '../../../models/organization/organization.model';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-organization-wizard-add',
    templateUrl: './organization-wizard-add.component.html',
    styleUrls: ['./organization-wizard-add.component.scss'],
    standalone: false,
})
export class OrganizationWizardAddComponent implements OnInit {
    @ViewChild(MatTabGroup) tabs?: MatTabGroup;

    selectedTab: number = 0;
    selectedTabLabel: string = 'Details';
    isFederatedOrganization: boolean;
    userCount = 0;
    userTypeSubscription: Subscription;
    isDisableOrgTab: boolean;
    isDisableAzureDetailTab: boolean = true;
    isDisableUsersTab: boolean = true;
    isDisableUserTypeTab: boolean = true;
    isDisableInstanceTab: boolean = true;
    index = 0;
    indexOld = 0;
    isViewEnabled: boolean = false;
    isDisableBack: boolean = false;
    OrgData: Organization;
    securityRolesData;
    isOrgFormValid: boolean = false;
    OrganizationId: string;
    isEditMode: boolean = null;
    constructor(
        private organizationDataService: OrganizationDataService,
        private userUtilityServices: UserUtilityService,
        private activatedRoute: ActivatedRoute,
        private cd: ChangeDetectorRef
    ) {
        this.isFederatedOrganization = false;
    }

    async ngOnInit(): Promise<void> {
        this.isViewEnabled = await this.userUtilityServices.checkUserPermissionDataAndRoute('org-SecurityRole', userActions.View);
        this.activatedRoute.paramMap.subscribe((params) => {
            const id = params.get('id');
            if (id) {
                // this.isEditMode = true;
                this.OrganizationId = id;
                this.isEditMode = true;
            } else {
                this.isEditMode = false;
            }
        });
        // organization edit mode
        this.isDisableAzureDetailTab = true;
        this.isDisableUserTypeTab = true;
        this.isDisableUsersTab = true; //set defult to true
        this.isDisableInstanceTab = true;

        this.handleSubscription();
    }

    handleSubscription() {
        // organization tab DISABLE
        this.organizationDataService.isDisableOrgTab$.subscribe((value) => {
            this.isDisableOrgTab = value;
        });

        // azure-ad tab HIDE/UNHIDE
        this.organizationDataService.isFederatedOrganization$.subscribe((value) => {
            this.isFederatedOrganization = value;
        });

        // azure ad tab DISABLE
        this.organizationDataService.isDisableAzureDetailWizard.subscribe((value) => {
            this.isDisableAzureDetailTab = value;
        });

        // user-type tab DISABLE
        this.organizationDataService.isDisableUserTypeWizard.subscribe((result) => {
            this.isDisableUserTypeTab = result;
        });

        // users tab DISABLE
        this.organizationDataService.isDisableUsersWizard.subscribe((result: boolean) => {
            this.isDisableUsersTab = result;
        });

        this.organizationDataService.isDisableInstanceWizard.subscribe((result: boolean) => [(this.isDisableInstanceTab = result)]);
        // navigation throughout tabs
        this.organizationDataService.navigateThroughWizard.subscribe((result: number) => {
            this.selectedTab = result;
            this.cd.detectChanges();
        });

        this.organizationDataService.numberOfUsers.subscribe((totalUsers: number) => {
            this.userCount = totalUsers;
        });

        this.organizationDataService.isDisableBackButton$.subscribe((value) => {
            this.isDisableBack = value;
        });
    }

    setTheTabIndex(index: number) {
        this.selectedTab = index;
    }

    tabChangeFromTabs(event: MatTabChangeEvent) {
        this.selectedTab = event.index;
        this.selectedTabLabel = event.tab.textLabel;
        this.organizationDataService.activeOrganizationTab.next(this.selectedTabLabel);
    }

    nextButtonClick() {
        if (this.selectedTabLabel == 'Details') {
            if (this.OrganizationId) {
                this.organizationDataService.organizationTabNext.next(this.selectedTabLabel);
            } else {
                this.organizationDataService.organizationTabNextCreate.next(this.selectedTabLabel);
            }
        } else {
            this.organizationDataService.organizationTabNext.next(this.selectedTabLabel);
        }
    }

    backClick() {
        this.organizationDataService.OrganizationTabBack.next(this.selectedTabLabel);
    }
    onFormStatusChange(isValid: boolean) {
        this.isOrgFormValid = isValid;
    }
}
